import axios from '../../helper/axios';

import config from '../../../config.json';
const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
const BACKEND_URL = config.api[env];

export function getArea(areaId) {
  return axios.get(`${BACKEND_URL}/area/${areaId}`);
}
